import model from "@js/model.js";
import { isObject } from "@helpers/utils.js"
import Enum from "@shared/enum.js";
import { watch } from "vue";


let initialState = null;

let forcedObservables = {
	max: {},
	count: {},
	resolveCallback: null,
	timeout: null,
};

window.testForcedObservables = function(){
	return forcedObservables;
}

export default {
	shouldAvoidPopstate(e){
		let cat = this.getCatByCatID(e.ids.level1);
		if(cat && cat.page === Enum.Pages.WEBRES && cat.id !== Enum.CATEGORY_IDS.WEBRES) return true;

		if(e.isPopState) return true;
	},
	initPopState(){
		if(model.view == Enum.Views.CASHIER) return;
	
		var modalPopState = false;

		model.on('OpenFilter', e => {
			!e.isPopState && !model.observables.filterDisplayed && addState({
				type: 'filter'
			});
		});
	
		model.on('GoToCategory', e => {
			if(this.shouldAvoidPopstate(e)) return;

			addState({
				type: 'category',
				ids: e.ids,
				forceScroll: e.forceScroll,
				scroll: e.scroll,
				promoId: e.promoId,
				webResInfo: model.webResInfo,
			}, e.userInteracted);
		});
	
		model.on('GoTo', () => {
			!modalPopState && addState({
				type: 'modal',
			});
			modalPopState = false;
		});

		model.on('OpenGameFrame', () => {
			addState({
				type: 'gameFrame',
			});
		});

		watch(() => model.observables.gameDisplayedObs, value => {
			if(!value) return;

			addState({
				type: 'gamePlay',
			});
		});
	
		window.addEventListener('popstate', () => {
			var state = history.state;

			if(!state) state = initialState;

			window.currentState = state;

			if(!isObject(state)) return;

			if(model.observables.filterDisplayed){
				model.dispatchEvent('OpenFilter', {
					isPopState: true,
				});
				return;
			}

			if(model.observables.gameFrameDisplayed){
				model.dispatchEvent('CloseGameFrame');
				return;
			}

			if(this.anyModals()){
				this.activeModals.length > 1 && (modalPopState = true);
				this.closeActiveModal();
				return;
			}

			if(model.observables.gameDisplayedObs){
				this.destroyAllGames();
				return;
			}

			switch(state.type){
				case 'category' : 
					if(state.promoId){
						this.loadPromoWin({
							id: state.promoId,
							isPopState: true,
						});
					}
					else {
						model.webResInfo = state.webResInfo;
						if(isObject(model.webResInfo)){
							model.observables.webresShowNav = model.webResInfo.showNav;
							model.observables.webresShowCommonSectionBottomWave = model.webResInfo.showCommonSectionBottomWave;
						}
						this.gotoCategory(state.ids, {forceScroll: state.forceScroll, srcoll: state.srcoll, isPopState: true, ignoreIsSame: true}); 
					}
					break;
			}
		});
	},
}

function addState(params, userInteracted){
	if(typeof userInteracted !== 'boolean') userInteracted = true;

	if(!userInteracted){
		initialState = JSON.parse(JSON.stringify(params));
		return;
	}
	
	window.currentState = params;
	history.pushState(params, 
	document.title, 
	window.location.pathname + window.location.search);
}